import teamMembers from "@/data/team-members";

export default function TeamGrid({ members = teamMembers, className = "", ariaLabel = "Obsero team" }) {
  const classes = ["public-team-grid", className].filter(Boolean).join(" ");

  return (
    <div className={classes} aria-label={ariaLabel}>
      {members.map((member) => {
        const hasPhoto = Boolean(member.photo);
        const mediaClasses = ["public-team-card__media", hasPhoto ? "is-filled" : ""]
          .filter(Boolean)
          .join(" ");

        return (
          <article key={member.name} className="public-team-card">
            <div className={mediaClasses}>
              {hasPhoto ? (
                <img
                  className="public-team-card__image"
                  src={member.photo}
                  alt={member.alt || member.name}
                  loading="lazy"
                  decoding="async"
                  style={member.objectPosition ? { objectPosition: member.objectPosition } : undefined}
                />
              ) : (
                <div className="public-team-card__placeholder" aria-hidden="true">
                  <span className="public-team-card__initials">{member.initials}</span>
                  <span className="public-team-card__label">Billede kommer</span>
                </div>
              )}
            </div>
            <div className="public-team-card__footer">
              <div className="public-team-card__name">{member.name}</div>
              {member.role ? <div className="public-team-card__role">{member.role}</div> : null}
            </div>
          </article>
        );
      })}
    </div>
  );
}
